import React, { useState } from 'react';
import { Checkbox, Dropdown, Menu, Button, Space } from 'antd';
import { DownOutlined } from '@ant-design/icons';

interface SucursalOption {
  label: string;
  value: string;
  color: string;
}

interface SucursalCheckboxGroupProps {
  options: SucursalOption[];
  selectedValues: string[];
  onChange: (selected: string[]) => void;
}

const OptionsSucursales: React.FC<SucursalCheckboxGroupProps> = ({
  options,
  selectedValues,
  onChange,
}) => {

  const handleCheckboxChange = (val: any) => {
    onChange(val);
  };
  const [openDropdown, setOpenDropdown] = useState(false);

  const handleDropdownCheckboxChange = (checked: boolean, value: string) => {
    const newSelected = checked
      ? [...selectedValues, value]
      : selectedValues.filter((v) => v !== value);
    onChange(newSelected);
  };

  const toggleDropdown = () => {
    setOpenDropdown(!openDropdown);
  };

  return (
    <div className="flex flex-wrap items-center gap-4 mb-4">
      <Checkbox.Group value={selectedValues} onChange={handleCheckboxChange}>
        <Space size="middle" wrap>
          {options.slice(0, 3).map((opcion) => (
            <label key={opcion.value} className="flex items-center gap-2 cursor-pointer">
              <input
                type="checkbox"
                checked={selectedValues.includes(opcion.value)}
                onChange={(e) =>
                  handleDropdownCheckboxChange(e.target.checked, opcion.value)
                }
                style={{
                  width: '16px',
                  height: '16px',
                  borderRadius: '3px',
                  border: `2px solid ${opcion.color}`,
                  backgroundColor: selectedValues.includes(opcion.value)
                    ? opcion.color
                    : 'transparent',
                  appearance: 'none',
                  transition: 'all 0.2s ease',
                  cursor: 'pointer',
                }}
              />
              <span className="text-sm">{opcion.label}</span>
            </label>
          ))}
          {options.length > 3 && (
            <Dropdown
              overlay={
                <Menu>
                  {options.slice(3).map((opcion) => (
                    <Menu.Item key={opcion.value}>
                      <label className="flex items-center gap-2 cursor-pointer">
                        <input
                          type="checkbox"
                          checked={selectedValues.includes(opcion.value)}
                          onChange={(e) =>
                            handleDropdownCheckboxChange(e.target.checked, opcion.value)
                          }
                          style={{
                            width: '16px',
                            height: '16px',
                            borderRadius: '3px',
                            border: `2px solid ${opcion.color}`,
                            backgroundColor: selectedValues.includes(opcion.value)
                              ? opcion.color
                              : 'transparent',
                            appearance: 'none',
                            transition: 'all 0.2s ease',
                            cursor: 'pointer',
                          }}
                        />
                        <span className="text-sm">{opcion.label}</span>
                      </label>
                    </Menu.Item>
                  ))}
                </Menu>
              }
              trigger={['click']}
              open={openDropdown}
              onOpenChange={toggleDropdown}
            >
              <Button type="link" style={{ padding: 0 }}>
                Ver más <DownOutlined />
              </Button>
            </Dropdown>
          )}

        </Space>
      </Checkbox.Group>
    </div >
  );
};

export default OptionsSucursales;
